import { BookOpen, Sparkles, Globe, ChevronDown } from "lucide-react";

const bullets = [
  "Series B funding round, $40M raised in 2024 (TechCrunch)",
  "B2B logistics platform serving mid-market retailers",
  "Recent partnership announcement with FedEx (March 2025)",
  "Key competitors: Flexport, Convoy",
];

export const SmartNotesMockup = () => {
  return (
    <div className="relative">
      {/* Floating "PRO FEATURE" badge */}
      <div className="absolute -top-3 -left-3 z-10 hidden md:flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-brand-blue text-white text-[10px] font-mono uppercase tracking-wider shadow-fluent-md">
        <Sparkles className="w-3 h-3" />
        Pro Feature
      </div>

      <div className="rounded-xl border border-border/60 bg-card shadow-fluent-lg overflow-hidden">
        {/* Window header */}
        <div className="flex items-center justify-between px-4 py-2.5 bg-surface-1 border-b border-border/60">
          <div className="flex items-center gap-2 min-w-0">
            <BookOpen className="w-3.5 h-3.5 text-muted-foreground flex-shrink-0" />
            <span className="text-[11px] font-mono uppercase tracking-wider text-muted-foreground truncate">
              Smart Note · Northwind Labs
            </span>
          </div>
          <div className="flex items-center gap-1 flex-shrink-0">
            <span className="w-2 h-2 rounded-full bg-brand-orange/60" />
            <span className="w-2 h-2 rounded-full bg-success/60" />
          </div>
        </div>

        {/* Body */}
        <div className="p-4 sm:p-5 space-y-4">
          {/* Task selector chip */}
          <div className="flex items-center justify-between gap-2 px-3 py-2 rounded-md bg-surface-1 border border-border/60">
            <div className="flex items-center gap-2 min-w-0">
              <span className="text-[9px] font-mono uppercase tracking-wider text-muted-foreground">
                Task
              </span>
              <span className="text-xs font-medium truncate">Opportunity Summary</span>
            </div>
            <ChevronDown className="w-3.5 h-3.5 text-muted-foreground flex-shrink-0" />
          </div>

          {/* Bullet points */}
          <ul className="space-y-2.5">
            {bullets.map((b, i) => (
              <li
                key={i}
                className="flex items-start gap-2.5 text-xs sm:text-sm text-foreground/90 leading-relaxed animate-fade-in-up"
                style={{ animationDelay: `${i * 120}ms`, animationFillMode: "both" }}
              >
                <span className="mt-1.5 w-1 h-1 rounded-full bg-brand-blue flex-shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Footer strip */}
        <div className="flex items-center justify-between gap-2 px-4 py-2.5 bg-surface-1 border-t border-border/60">
          <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
            <Sparkles className="w-3 h-3 text-brand-blue" />
            Generated · 2.1s · 1.2 credits
          </div>
          <div className="hidden sm:flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
            <Globe className="w-3 h-3" />
            Live sources
          </div>
        </div>
      </div>
    </div>
  );
};
